const consulta_historico_de_vagas_por_escola = {
  path: "/consulta-historico-de-vagas-por-escola",
  redirect: "/consulta-historico-de-vagas-por-escola",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Consulta de Vagas",
  },
  children: [
    {
      path: "/consulta-historico-de-vagas-por-escola",
      name: "consulta_historico_de_vagas_por_escola",
      meta: {
        allowedPermissions: ["vaga_log_por_escola"],
      },
      component: () =>
        import(
          "@/views/ConsultaHistoricoDeVagasPorEscola/ConsultaHistoricoDeVagasPorEscola.vue"
        ),
    },
  ],
};

export { consulta_historico_de_vagas_por_escola };
